// AUTO-GENERATED — bundled fallback of the SERPRO CNH-e signing certificate list.
// Snapshot of https://vio.serpro.gov.br/api/v2/certificates (public certs, no PII).
// Purpose: hard-cache so CNH-e signature verification still works when the live
// endpoint is offline / CORS-blocked / down — SerproCertProvider merges these in as
// candidates so a genuine CNH-e verifies ('verified') instead of failing 'unverified'.
// Regenerate by re-fetching the endpoint. Snapshot taken 2026-07-02; 11 entries.

export interface BundledSerproCert {
  id: string;
  public_key: string;
  valid?: { from?: string; until?: string } | null;
  group?: { id?: string } | null;
}

export const SERPRO_CERTS_BUNDLED: BundledSerproCert[] = [
  {
    "id": "e32bfb4d-0177-4f48-9743-0b395f4df9a9",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1m78a+Sv+ANPO/2uEV91iajRGxjPK5gkrQjedjll81m04rYVvIaFhTO+6cBn+bRxOVW0usiJiA0h+HTtK+K34ODTxmaBqDhNWS+wBjjSmunTpvl8ay1ixiXQd3gxjp2EksYHzpr4vVswQv81xQ13CWTsKexdfug/Z/pV6FwnKi4bmTLolsDYxbhpS79Gwr18gyxElXIGR1JP4Lq73+k6hJaEoJ636XqPNaMngtGB1js1kHZQFJTFb9Uhd08fli1loHlFgbZzUl5OrL4EREoTeq49DwYEYfrR/l3LuxrGA7chjWctymDhaUVFqk0D3EfdIrCCl0Wc6qv4gd5fSXqFbwIDAQAB",
    "valid": {
      "from": "2024-03-27T10:00:00.000-03:00",
      "until": "2029-03-27T10:00:00.000-03:00"
    },
    "group": {
      "id": "c83d038e-6283-4a8a-82bc-9f0e03274296"
    }
  },
  {
    "id": "6f9ee12e-2bf9-42d1-bb46-a983ef01cf47",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2nx156a7yeR8C5ubTcFNgTy/N1/LD6FkWVxrO/qVTF2s74XtbDh352T5IBASOX/RqH232iIalSoH6t5+rOxBvzonquJGKROYE3lxTDgKpy+0pxqIK/z3Gfn5wHsAhtH0rxZHNOyy2UH3uhDkdO9/Y/X+RGCwhtEzdULCAUIEuhih8bdaKnGSAMCoNYKFzXQ1rsnQSRDowXdLvNB6o4QRWKUOf8OQcwCZLnu/U3HaISsO6ADUps1NLIt137FmBbez/tOUu0WC0zs0jqmDDsIfw5gtwAIJu2uJF+Huhi3wNRsbs+cGm/CirdQHxaIwp4cyzSWJCn44c3n+PKt37AqiFwIDAQAB",
    "valid": {
      "from": "2019-03-26T10:00:00.000-03:00",
      "until": "2024-03-26T10:00:00.000-03:00"
    },
    "group": {
      "id": "c83d038e-6283-4a8a-82bc-9f0e03274296"
    }
  },
  {
    "id": "2ec35447-7fc3-4fcd-8131-2185c9b5f3e6",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAojvNLUEOyzAmjj+Lzs+nfNirYsnkLjw5exUdwMuDp1l2+6KEiPQ2yjLOqsczR+GB652t0+AZjd69MhYMOcVqkw8oe/ZL3CGl5jtcahzu0I1ZMep/cpyPoeP7jKh7lBCWrajg7tLufymNnFhcgVZkr3qFYD6GxWQMJXo/yyz/Fqhaj1rcudEWD9orzAdxsXMBjZ29C2pQYlUUfp4q/ERoViC+VR1RyDSM5kOhS+XAUXEKdT6QEoz+XfgsiYVZT5XDANYbEbf4XjDxp7Jd/xoMK6O4jiRhqZLlV1tXxzW+JQ0PcLMMcGeQK7eyklDvpBQY6iFGAdkt99KtSEN73sEEHwIDAQAB",
    "valid": {
      "from": "2017-04-29T10:50:00.000-03:00",
      "until": "2022-04-29T10:50:00.000-03:00"
    },
    "group": {
      "id": "37234581-512c-4906-a4ea-591d25dee539"
    }
  },
  {
    "id": "fffc444f-99eb-46af-9987-409042e65c09",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr3+FT8Gy+tIdCPOULLnHye3t+IED7gtOtJUKTellW2PvPjCwNPCEZjEYohhtdwhR7wEHyPHmt09WlFzOShYCV5RvwJhgaCH3YdDWxD329Hd/zQXx64gCYluzoM/Fj/Y1bu7UbtKrNnyEbLqyrVLjhfnSNh2hLPRh8ayUwPwQyiGeA4Wt3hixdrmzLFv/BbVF4jxTcEHHocqY0t351hcZzpTrirYXgmjCM8sPt4GEvOQE61hDZjQaWeZu3iRT8YVQBNRV9mQL8KSLimFGlgNiO42Vk63gxsd2RsGbl9xrEU/2HpYwqzHxqorrZn/7j1CWqshS9gmJtWgF+YtrmrdOswIDAQAB",
    "valid": {
      "from": "2022-04-14T00:00:00.000-03:00",
      "until": "2027-04-14T00:00:00.000-03:00"
    },
    "group": {
      "id": "37234581-512c-4906-a4ea-591d25dee539"
    }
  },
  {
    "id": "b44a0d6d-d738-4d7d-b51a-7d326d304f6f",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3VuwmVyPsUFEol9I9Aa4adKWpm2cAfWH/hG86/aJQ+0B7BIaFQuVOGC55revfH+BExldyEHhDYNZN2lI3hK4cryBYFD4npsH/wIMjgKtfqT3fEGHmxr2oGYK9EXPieL/La6qKVro2aQPq8mFAUcWpJ6nr0GFrBLS0rYzoR2rPRa6FZiyD2j0aFSlh0x6i64SSxew8ggjmoT2VLuiUm79TNVDV7+3NqTokXaInM6oD218yFAizE0G6nD9Zxba+/fB8hgu9TGCCB3FSRaH2h+htjlzJnHNkjI4ByLwg3/sJIt5iY1+vsodvGj5oMQ/R3CUCH7MlxTJA4b2sN18i9Q0TQIDAQAB",
    "valid": {
      "from": "2017-04-29T10:50:00.000-03:00",
      "until": "2022-04-29T10:50:00.000-03:00"
    },
    "group": {
      "id": "07008c00-518d-4ecb-b257-62d3c7376636"
    }
  },
  {
    "id": "f114b7d1-7955-4d9f-9b82-35b8d9a612d5",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0sqIT8+FOCKf9GSjC9rRASwt7mukTv/ubVHqS0JpcnsxQDrYqsQX5c1eMA7JgNoXfj6qO++lWv2WL32C5zxV96aLCFQkZQTQn+mXyUfYQYbA7gQEM8IbEKZPAUkjuZU2yOAB7yEdsnL1eOF0JGY8AD/ajD3lxbhiKDBjoDbfPufE7npJpgYdvjkaZ6Gn/xFxKvr/86Gk5TEQzGXZcoNtn+21Y7XAxKmwjFYlCWPLlRwKajbZyt/04Lsa3p1vj7Sw+nHlCDZAqWY5SZ/YMpuPa37WVmP46h3g8UdXRiG9lw4I7RAxVDhVdlpHN4bnaU3HOnIoWTXYZnTYETfbKIEOjQIDAQAB",
    "valid": {
      "from": "2022-04-14T00:00:00.000-03:00",
      "until": "2027-04-14T00:00:00.000-03:00"
    },
    "group": {
      "id": "07008c00-518d-4ecb-b257-62d3c7376636"
    }
  },
  {
    "id": "f8d8ad78-26c7-4384-b3f4-a5692c669e59",
    "public_key": "MFowFAYHKoZIzj0CAQYJKyQDAwIIAQEHA0IABHPSI/ixqDisXDdGW3FRh5/XYyI9kNdyt4sE07Y4OrOQn7BC5QYuxfzmoODuXs4A0YPSTsjybaPcyUo8GSMfzqA=",
    "valid": {
      "from": "2019-08-13T08:00:00.000-03:00",
      "until": "2029-08-13T08:00:00.000-03:00"
    },
    "group": {
      "id": "1bef1e3b-01f7-4e1b-a42f-11cacbec9f13"
    }
  },
  {
    "id": "89f7c646-aed8-45c3-a064-49a9a7b89d13",
    "public_key": "MFowFAYHKoZIzj0CAQYJKyQDAwIIAQEHA0IABIY16w7w6Zm3eVVfaiRUviUgKAjro1qgSFEj28x9UY3THwlUY6jhsJycpTca+ZvriJGWczRq/FpoSO6b64UzlBk=",
    "valid": {
      "from": "2019-08-13T08:00:00.000-03:00",
      "until": "2029-08-13T08:00:00.000-03:00"
    },
    "group": {
      "id": "9d43dcc4-72fb-4f14-8af0-efcf8ba1a97a"
    }
  },
  {
    "id": "b3ba1091-e72f-4f4a-904b-b57977c9c359",
    "public_key": "MFowFAYHKoZIzj0CAQYJKyQDAwIIAQEHA0IABFhQnsq0O/mk68AKa+RTPgW3c9DmYEseddgc/qGFSDwcOOpHtaBPYPCiQnjXiXB017FHQonWBX9gmxwCC81qIvQ=",
    "valid": {
      "from": "2019-08-13T08:00:00.000-03:00",
      "until": "2029-08-13T08:00:00.000-03:00"
    },
    "group": {
      "id": "36bbdb5f-28e6-47a8-8b48-9a2a2ae2fed3"
    }
  },
  {
    "id": "7016a8bc-b4e1-40fc-a509-973227355126",
    "public_key": "MFowFAYHKoZIzj0CAQYJKyQDAwIIAQEHA0IABHxKU3gWMkn5J4UvqvhQOw2SmiOQy/dS2YYm74PfgsF3WscdxbddO7d+UVzMk98MrHpu4qO8V6m89NSE8OS2ibg=",
    "valid": {
      "from": "2019-08-13T08:00:00.000-03:00",
      "until": "2029-08-13T08:00:00.000-03:00"
    },
    "group": {
      "id": "6d15023d-bdb8-4860-b73f-cb66934369f4"
    }
  },
  {
    "id": "e4081d9a-a179-4458-b4b3-1503f857b8a3",
    "public_key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnvvQIfBQe287+saTX/jKUyvcbPfr3r/Tsmq418nY6E8ailYnXH2j+FReffUdvRdik4hYkk5AL/YVShXKdcgv0VmujlauFi/2fsAYcwRLMiG1BDdw5LRkgAP/R7u6WMLemwT74CANPRKHnKvjkk1kTwE8Y61Rh5kWEznnO1s92KjVxaRqH7UBaGFofEa5mhd31CeJ96xV8p8vdJsIPAJQ5SHX1XlmcuUcR+cA2Q7wtmKgvQgJqnJ5lmKXDsJfRAKUd9kf8lVmMflBE5+ViCN6p2Reaw4g5j3qN9YInPsRYGegztZ4yrLqXnC7YorK6PyA+ZC9tmAm6Ue7g/0GRvsziwIDAQAB",
    "valid": {
      "from": "2018-01-14T22:00:00.000-02:00",
      "until": "2023-01-14T21:00:00.000-03:00"
    },
    "group": {
      "id": "bb7a9a25-ffc6-47c2-8c06-7eb45bd140bb"
    }
  }
];
